import React, { useEffect, useState } from "react";
import {
    adminGetAllSubAdmins,
    adminDeleteSubAdmin
} from "../api/admin";
import SubAdminTable from "../components/SubAdminTable";
import SubAdminForm from "../components/SubAdminForm";
import PermissionModal from "../components/PermissionModal";
import "./SubAdminsPage.css";

const SubAdminsPage = () => {
    const [subadmins, setSubadmins] = useState([]);
    const [editingSubAdmin, setEditingSubAdmin] = useState(null);
    const [permissionModalSubAdmin, setPermissionModalSubAdmin] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showForm, setShowForm] = useState(false);
    const [showPermissions, setShowPermissions] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const clearAll = () => {
        setEditingSubAdmin(null);
        setPermissionModalSubAdmin(null);
        setShowForm(false);
        setShowPermissions(false);
    };

    const fetchSubAdmins = async () => {
        setLoading(true);
        try {
            const res = await adminGetAllSubAdmins();
            setSubadmins(res.data || []);
        } catch (error) {
            console.error("Error fetching sub-admins:", error);
            setSubadmins([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSubAdmins();
    }, []);

    const filteredSubAdmins = (subadmins || []).filter(sa => {
        const term = searchTerm.toLowerCase();
        return (
            (sa.name || "").toLowerCase().includes(term) ||
            (sa.username || sa.email || "").toLowerCase().includes(term)
        );
    });

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this sub-admin?")) return;
        try {
            await adminDeleteSubAdmin(id);
            fetchSubAdmins();
        } catch (error) {
            console.error("Error deleting sub-admin:", error);
        }
    };

    const handleEdit = (subadmin) => {
        setEditingSubAdmin(subadmin);
        setShowForm(true);
    };

    const handleManagePermissions = (subadmin) => {
        setPermissionModalSubAdmin(subadmin);
        setShowPermissions(true);
    };

    return (
        <div className="admin-page">
            {!showForm && !showPermissions ? (
                <>
                    <div className="page-header">
                        <h2 className="adminproducts">Sub-Admin </h2>
                        <div className="header-actions">
                            <div className="search-container">
                                <span className="search-label">Search:</span>
                                <input
                                    type="text"
                                    className="user-search-input"
                                    placeholder="Search by name or email..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                            <div className="header-controls-row">
                                <div className="admin-count-badge">
                                    Total: {subadmins.length}
                                </div>
                                <button className="btn-add-product" onClick={() => { setEditingSubAdmin(null); setShowForm(true); }}>
                                    + Create Sub-Admin
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="table-section">
                        {loading ? (
                            <div className="loading-container">Loading sub-admins...</div>
                        ) : (
                            <SubAdminTable
                                subadmins={filteredSubAdmins}
                                onDelete={handleDelete}
                                onEdit={handleEdit}
                                onManagePermissions={handleManagePermissions}
                            />
                        )}
                    </div>
                </>
            ) : showForm ? (
                <>
                    <div className="page-header">
                        <div className="header-with-back">
                            <button className="back-btn" onClick={clearAll}>← Back to List</button>
                            <h2 className="adminproducts">
                                {editingSubAdmin ? "Update Sub-Admin" : "Create New Sub-Admin"}
                            </h2>
                        </div>
                    </div>
                    <div className="form-inline-container">
                        <SubAdminForm
                            subadmin={editingSubAdmin}
                            onSuccess={() => {
                                fetchSubAdmins();
                                clearAll();
                            }}
                            onCancel={clearAll}
                        />
                    </div>
                </>
            ) : (
                <>
                    <div className="page-header">
                        <div className="header-with-back">
                            <button className="back-btn" onClick={clearAll}>← Back to List</button>
                            <h2 className="adminproducts">
                                Manage Permissions - {permissionModalSubAdmin?.name}
                            </h2>
                        </div>
                    </div>
                    <div className="form-inline-container">
                        <PermissionModal 
                            subadmin={permissionModalSubAdmin}
                            onClose={clearAll}
                            onSuccess={() => {
                                fetchSubAdmins();
                                clearAll();
                            }}
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default SubAdminsPage;

